module.exports = __webpack_public_path__ + "static/media/strong14.088bea1b.jpg";